import type React from 'react'

import { Navigate, useNavigate, useSearch } from '@tanstack/react-router'

import { useFirebaseUser } from '@/auth/useFirebaseUser.ts'
import { OperatingRegionsView } from '@/components/templates/OperatingRegionsView'

import { useOperatingRegionsPage } from './useOperatingRegionsPage'

export const OperatingRegionsPage: React.FC = () => {
  const user = useFirebaseUser()
  const { showTest, date } = useSearch({ from: '/regions/' })
  const navigate = useNavigate()
  const { regions, isHistoricalMode, availableDates } = useOperatingRegionsPage({ showTest, selectedDate: date })

  if (!user?.sys_admin) {
    return <Navigate to="/" search={{ central_id: undefined }} replace />
  }

  const handleDateChange = async (newDate: string | undefined) => {
    await navigate({ to: '/regions', search: { showTest, date: newDate } })
  }

  return (
    <OperatingRegionsView
      regions={regions}
      selectedDate={date}
      isHistoricalMode={isHistoricalMode}
      availableDates={availableDates}
      onDateChange={handleDateChange}
      onBackToPiloteClicked={async () => {
        await navigate({ to: '/', search: { central_id: undefined } })
      }}
    />
  )
}
